import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { deRegisterFlyout, hideFlyout, registerFlyout } from 'src/app/root-store/flyout-store/flyout.actions';
import { selectIsShowFlyout } from 'src/app/root-store/flyout-store/flyout.selectors';

@Component({
    selector: 'nova-flyout',
    templateUrl: './flyout.component.html',
    styleUrls: ['./flyout.component.scss'],
    standalone: true,
    imports: [RouterModule, AsyncPipe, NgTemplateOutlet]
})
export class FlyoutComponent implements OnInit, OnDestroy {
    @Input() title: string;
    @Input() contentTemplate: any;
    @Input() flyoutId: string;
    @Input() fullListLink = '#';

    show$: Observable<boolean>;

    constructor(private readonly store: Store) {}

    ngOnInit() {
        this.store.dispatch(registerFlyout({ id: this.flyoutId }));
        this.show$ = this.store.select(selectIsShowFlyout(this.flyoutId));
    }

    ngOnDestroy() {
        this.store.dispatch(deRegisterFlyout({ id: this.flyoutId }));
    }

    onCloseFlyoutClicked(): void {
        this.store.dispatch(hideFlyout({ id: this.flyoutId }));
    }
}
